var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.5V34.5",
    stroke: "#6E7191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 7.5H14.25C12.8576 7.5 11.5223 8.05312 10.5377 9.03769C9.55312 10.0223 9 11.3576 9 12.75C9 14.1424 9.55312 15.4777 10.5377 16.4623C11.5223 17.4469 12.8576 18 14.25 18H21.75C23.1424 18 24.4777 18.5531 25.4623 19.5377C26.4469 20.5223 27 21.8576 27 23.25C27 24.6424 26.4469 25.9777 25.4623 26.9623C24.4777 27.9469 23.1424 28.5 21.75 28.5H9",
    stroke: "#6E7191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollarSign.750d61d7df72dfa12601efc144873f82.svg";
export { ForwardRef as ReactComponent };